import { Checkbox } from "@/components/ui/checkbox";
import { LEGAL_COMMERCIAL_3_VERSION } from "@/modules/legal/legalDocumentsCatalog";

export const LEGAL_ACCEPTANCE_CHECKBOX_LABEL =
  "He leído y acepto los Términos y condiciones de uso, el Aviso de privacidad, el Alcance de módulos y las Responsabilidades, soporte, garantía limitada y reembolso proporcional de BNT Sistema Empresarial, versión 1.0.";

export const LEGAL_ACCEPTANCE_AUXILIARY_TEXT =
  "Esta aceptación se guardará como evidencia electrónica de la solicitud de licencia.";

/**
 * Checkbox obligatorio de aceptación legal — Comercial 3C.
 */
export default function LegalAcceptanceCheckbox({
  checked = false,
  onCheckedChange,
  disabled = false,
  locked = false,
  contractVersion = LEGAL_COMMERCIAL_3_VERSION,
  documents = [],
}) {
  const versionLabel = contractVersion || LEGAL_COMMERCIAL_3_VERSION;
  const isDisabled = disabled || locked;

  return (
    <div
      className="rounded-sm border border-slate-200 bg-slate-50 px-3 py-3 space-y-2"
      data-testid="legal-acceptance-checkbox-block"
    >
      <label className={`flex items-start gap-2 text-[11px] text-slate-800 ${isDisabled ? "cursor-default" : "cursor-pointer"}`}>
        <Checkbox
          checked={locked ? true : checked}
          onCheckedChange={(v) => {
            if (locked) return;
            onCheckedChange?.(v === true);
          }}
          disabled={isDisabled}
          data-testid="legal-acceptance-checkbox"
        />
        <span>
          {LEGAL_ACCEPTANCE_CHECKBOX_LABEL.replace("versión 1.0", `versión ${versionLabel}`)}
        </span>
      </label>
      <p className="text-[10px] text-slate-600 m-0" data-testid="legal-acceptance-auxiliary">
        {LEGAL_ACCEPTANCE_AUXILIARY_TEXT}
      </p>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px]">
        <a
          href="/legal/documentos"
          className="text-[#0F2D5C] font-semibold underline underline-offset-2"
          data-testid="legal-acceptance-documents-link"
        >
          Consultar documentos legales
        </a>
        {Array.isArray(documents) && documents.length > 0 ? (
          <span className="text-slate-500" data-testid="legal-acceptance-doc-count">
            {documents.length} documento(s) vigente(s)
          </span>
        ) : null}
      </div>
    </div>
  );
}
